import {
    RegulationMenuItemFactoryBase
} from "../../menu-items-common/regulations-specific/regulation-menu-item-factory-base";
import {MenuItemKey} from "../../configurations/config-data-sections/generated-config-const";
import {IMenuItemRenderer} from "../../menu-items-common/renderer/menu-item.renderer.interface";
import {MichiganSportSideMenuItemRenderer} from "./side-menu/michigan.sport-side-menu-item.renderer";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IMenuItemActionFactoryService} from "../../menu-item-action-factory/menu-item-action-factory.service.interface";

export class MichiganMenuItemFactory extends RegulationMenuItemFactoryBase {
    getSideMenuItem(key: MenuItemKey, configReader: IMenuItemConfigReader, menuItemActionFactory: IMenuItemActionFactoryService): IMenuItemRenderer | null {
        switch (key) {
            case "sportCrossBrandMenuItem":
                return new MichiganSportSideMenuItemRenderer(configReader, this.services, menuItemActionFactory);
            default:
                return super.getSideMenuItem(key, configReader, menuItemActionFactory);
        }

    }
}